module.exports = __webpack_public_path__ + "static/sponsorship_img-07-c@2x-e8fefffb4c0ac4d5eacc6a87a7cf7f7a.jpg";